import { objectWithoutProperties as _objectWithoutProperties, extends as _extends, objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import 'react';
import { useForm } from 'react-hook-form';
import 'use-context-selector';
import { jsx } from '@emotion/react';
import '../../contexts/internal/StickyContext.js';
import '../../contexts/internal/EditorContext.js';
import { useCouponContext } from '../../contexts/external/CouponContext.js';
import '../../components/Canvas/Canvas.style.js';
import '../../components/Canvas/PreviewModeContainer.js';
import '../../components/Duration/DurationInput.js';
import '../../components/FieldItem.js';
import '../../components/FormGroup/FormGroup.js';
import { LogDataFormGroup } from '../../components/FormGroup/LogDataFormGroup.js';
import '../../components/Header/index.js';
import '../../components/Input/ColorPickerField/index.js';
import '../../components/Input/URLInput.js';
import '../../components/Inspector/Inspector.js';
import '../../components/TreeList/TreeList.style.js';
import '@react-icons/all-files/hi/HiChevronDown';
import '@react-icons/all-files/hi/HiChevronRight';
import '@react-icons/all-files/ri/RiCloseCircleFill';
import '@react-icons/all-files/ri/RiDeleteBinLine';
import '@react-icons/all-files/ri/RiFileCopyLine';
import '@react-icons/all-files/ri/RiShapeLine';
import 'qs';
import 'query-string';
import '@react-icons/all-files/md/MdLens';
import 'lodash-es';
import '@bucketplace/ui';
import '@bucketplace/bucket-log';
import 'react-dom';
import '../../components/Tooltip/Tooltip.js';
import '../../components/Toolbar/Toolbar.style.js';
import '../../components/TreeList/Draggable.js';
import '../../components/EditorPlaceholder/EditorPlaceholder.js';
import '../../components/FormContent.js';
import { InspectorFormProvider } from '../../components/InspectorFormProvider.js';
import { IdFormGroup } from './CouponInspector/IdFormGroup.js';

var _excluded = ["children"];
function CouponInspector(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange;
  return jsx(CouponInspectorContent, {
    value: value,
    onChange: onChange
  });
}
function CouponInspectorContent(_ref2) {
  var _value$props;
  var value = _ref2.value,
    onChange = _ref2.onChange;
  var _ref3 = (_value$props = value.props) !== null && _value$props !== void 0 ? _value$props : {},
    cartCouponMoldId = _ref3.id,
    productCouponMoldId = _ref3.productCouponMoldId;
  var form = useForm({
    defaultValues: value.props,
    mode: 'onBlur'
  });
  var handleWrapBlock = function handleWrapBlock(couponMoldIds, productCouponMoldId) {
    if (couponMoldIds.length === 0 && productCouponMoldId.length === 0) {
      return;
    }
    var focusedNewCouponMoldsNode = _objectSpread2(_objectSpread2({}, value), {}, {
      children: [{
        key: null,
        type: 'image',
        props: {},
        children: []
      }],
      props: _objectSpread2(_objectSpread2({}, value.props), {}, {
        id: couponMoldIds.join(', '),
        productCouponMoldId: productCouponMoldId.join(', '),
        canChildFocus: true
      })
    });
    setTimeout(function () {
      var newCouponMoldsNode = _objectSpread2(_objectSpread2({}, focusedNewCouponMoldsNode), {}, {
        props: _objectSpread2(_objectSpread2({}, focusedNewCouponMoldsNode.props), {}, {
          canChildFocus: false
        })
      });
      form.reset(newCouponMoldsNode.props);
      onChange(newCouponMoldsNode);
    }, 10);
    onChange(focusedNewCouponMoldsNode);
  };
  return jsx(InspectorFormProvider, {
    value: value,
    form: form,
    onChange: onChange
  }, jsx(LogDataInput, {
    value: value
  }), jsx(IdFormGroup, {
    cartCouponMoldId: cartCouponMoldId,
    productCouponMoldId: productCouponMoldId,
    onChange: handleWrapBlock
  }));
}
function LogDataInput(_ref4) {
  var value = _ref4.value;
  var _useCouponContext = useCouponContext(),
    setLogData = _useCouponContext.setLogData;
  var _ref5 = value !== null && value !== void 0 ? value : {};
    _ref5.children;
    var others = _objectWithoutProperties(_ref5, _excluded);
  return jsx(LogDataFormGroup, _extends({
    nodeKey: value === null || value === void 0 ? void 0 : value.key
  }, setLogData === null || setLogData === void 0 ? void 0 : setLogData(others)));
}

export { CouponInspector };
//# sourceMappingURL=Coupon.inspector.js.map
